import React, { useState, useEffect } from "react";
import { Col, Row, Card, Button, Modal, Form } from "react-bootstrap";

import { Comment } from "./Comment";
import ModalCommentBox from "./ModalCommentBox";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { isMobile } from "react-device-detect";
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import ApiAmusementService from "../../../../core/api/api.amusementService";
import StarsComments from "./StarsComments";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment-jalaali";
import { IconArrowRight } from "../../../../assets/icons";
moment.locale("fa");
moment.loadPersian();

function CommentSlider(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const testimonials = props?.amusementService?.amusementTestimonials;
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    reset,
  } = useForm({
    defaultValues: { id: 0, worthBuying: 0, qualityServices: 0, isThriller: 0 },
  });

  const [show, setShow] = useState(false);
  const [stateAddTestimonialModal, setStateAddTestimonialModal] =
    useState(false);
  const [rating1, setRating1] = useState(0);

  const handleClose = () => {
    setShow(false);
    navigate(`/details/${props?.amusementService?.urlName}`);
  };

  const handleShow = () => {
    navigate(`/details/${props?.amusementService?.urlName}/allComments`, {
      replace: true,
    });
    setShow(true);
  };

  const hideModal = () => {
    setStateAddTestimonialModal(false);
    setValue("worthBuying", 0);
    setValue("qualityServices", 0);
    setValue("isThriller", 0);
    navigate(`/details/${props?.amusementService?.urlName}`);
  };

  const showModal = () => {
    navigate(`/details/${props?.amusementService?.urlName}/comment`, {
      replace: true,
    });
    setStateAddTestimonialModal(true);
  };

  const onSubmit = async (data) => {
    //console.log("data", data);
    try {
      data.amusementServiceId = props.amusementService.id;
      let response = await ApiAmusementService.createAmusementTestimonial(data);
      //toast.configure();
      if (response.succeeded) {
        toast.success(response.message);
        reset();
        hideModal();
      } else toast.warn(response.message);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <Row className="pt-3 mt-3 mt-md-0 margin-bottom">
        <Col xs="6" md="8" className="my-auto">
          <h3
            className={`${
              isMobile ? "" : "fs-102"
            } fw-bold fs-normal  pb-3 pb-md-0 mb-0 ps-2 ps-md-0`}
          >
            نظرات خریداران
          </h3>
        </Col>
        {/* <Col xs={8} className="my-auto">
          <h3 onClick={handleShow} className={(!isMobile ? "text-xMedium mt-2 mb-4 font-weight-bold" : "font-weight-bold")}>
            
            نظرات خریداران
          </h3>
          <span>
            {" "}
            <a className="text-info d-inline-block d-lg-none text-small" onClick={handleShow}>
              ({testimonials?.length} نظر)
            </a>
          </span>
        </Col> */}
        <Col xs="6" md="4" className="text-end fs-075 mb-3">
          {/* {testimonials?.length > 0 ? (
            <span>{testimonials?.length} نظر ثبت شده</span>
          ) : (
            <Button
              variant="outline-primary"
              className="fs-075"
              onClick={showModal}
            >
              ثبت نظر شما
            </Button>
          )} */}
          {(testimonials?.length > 0 || isMobile) && (
            <Button
              className={isMobile && "fs-075"}
              variant="outline-primary"
              onClick={showModal}
            >
              ثبت نظر شما
            </Button>
          )}
        </Col>{" "}
        {location.pathname.indexOf("/allComments") !== -1 && (
          <Modal show={show} onHide={handleClose} fullscreen="md-down">
            <Modal.Header className="">
              <Modal.Title className="w-100">
                <div className="w-100 d-flex justify-content-between">
                  <div>
                    <div
                      className="large-svg d-inline-block"
                      onClick={handleClose}
                    >
                      <IconArrowRight fillColor="#000" />
                    </div>
                    نظرات خریداران{" "}
                  </div>
                  <div className="d-flex">
                    ({testimonials?.length}
                    <div className="fs-075 ps-1">نظر</div>)
                  </div>
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="mb-5 bg-light-1">
              <ModalCommentBox
                testimonials={testimonials}
                amusementService={props.amusementService}
              />
            </Modal.Body>
          </Modal>
        )}
        <Col xs={12} className="rounded-noImage-card pb-5">
          {testimonials?.length > 0 ? (
            isMobile ? (
              <div>
                <Swiper
                  className="rounded-3"
                  spaceBetween={10}
                  slidesPerView={1.3}
                >
                  {testimonials?.map((testimonial, index) => (
                    <SwiperSlide key={index} onClick={handleShow}>
                      <Comment
                        userFullName={
                          " " +
                          testimonial.name +
                          " " +
                          (testimonial.surname == null
                            ? ""
                            : testimonial.surname)
                        }
                        commentText={testimonial.text}
                        commentDate={testimonial.createdPersianTime}
                        totallyRank={testimonial.totallyRank}
                        commentid={testimonial.id}
                        likeCount={testimonial.likeCount}
                        disLikeCount={testimonial.disLikeCount}
                        showType="slider"
                        children={testimonial.children}
                      />
                    </SwiperSlide>
                  ))}
                  <SwiperSlide>
                    <Card className="w-100  rounded-3 border-0 h-100">
                      <Card.Body className="py-0 d-flex align-items-center justify-content-center">
                        <div className="text-small pr-1" onClick={handleShow}>
                          مشاهده همه
                        </div>
                        <div className="flipX ms-1 ">
                          <IconArrowRight fillColor="#000" />
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                </Swiper>

                <Row className="gx-2">
                  <Col xs="12">
                    <Button
                      variant="primary"
                      className="fs-09 w-100 mt-3"
                      onClick={handleShow}
                    >
                      مشاهده همه نظرات
                    </Button>
                  </Col>
                  {/* <Col xs="5">
                    <Button
                      variant="outline-primary"
                      className="fs-09 w-100 mt-3"
                      onClick={showModal}
                    >
                      ثبت نظر شما
                    </Button>
                  </Col> */}
                </Row>
              </div>
            ) : (
              testimonials?.map((testimonial, index) => (
                <Col key={index} className="mb-2">
                  <Comment
                    userFullName={
                      " " +
                      testimonial.name +
                      " " +
                      (testimonial.surname == null ? "" : testimonial.surname)
                    }
                    commentText={testimonial.text}
                    commentDate={testimonial.createdPersianTime}
                    totallyRank={testimonial.totallyRank}
                    commentid={testimonial.id}
                    likeCount={testimonial.likeCount}
                    disLikeCount={testimonial.disLikeCount}
                    children={testimonial.children}
                  />
                </Col>
              ))
            )
          ) : (
            <>
              <div className="col-12 text-small pt-md-3 text-muted">
                تاکنون نظری درباره این تفریح ثبت نشده است. شما اولین نظر را ثبت
                نمایید.
              </div>

              {!isMobile && (
                <Button className="mt-3" variant="primary" onClick={showModal}>
                  ثبت نظر شما
                </Button>
              )}
            </>
          )}
        </Col>
      </Row>
      {location.pathname.indexOf("/comment") !== -1 && (
        <Modal
          show={stateAddTestimonialModal}
          onHide={hideModal}
          fullscreen="md-down"
        >
          <Modal.Header>
            <Modal.Title className="w-100">
              <div className="fw-bold fs-09 w-100 ">
                <div className="large-svg d-inline-block" onClick={hideModal}>
                  <IconArrowRight fillColor="#000" />
                </div>
                ثبت نظر جدید
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-5 pb-md-0 bg-light">
            <form onSubmit={handleSubmit(onSubmit)} className="mb-5">
              <Row className="gx-2">
                <Col xs="6" sm="4" className="text-center mb-2 mb-md-3">
                  <div className="shadow-sm bg-white rounded-3 p-3">
                    <h5 className="text-dark fs-09">ارزش خرید </h5>
                    <Controller
                      name="worthBuying"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <StarsComments
                          vlu={value}
                          indexChangeComment={0}
                          startsChange={(index, value) => {
                            setValue("worthBuying", value);
                          }}
                          firstcount={1}
                        />
                      )}
                    />
                  </div>
                </Col>
                <Col xs="6" sm="4" className=" text-center mb-2  mb-md-3">
                  <div className="shadow-sm bg-white rounded-3 p-3">
                    <h5 className="text-dark fs-09">کیفیت خدمات </h5>
                    <Controller
                      name="qualityServices"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <StarsComments
                          vlu={value}
                          indexChangeComment={1}
                          startsChange={(index, value) => {
                            setValue("qualityServices", value);
                          }}
                          firstcount={6}
                        />
                      )}
                    />
                  </div>
                </Col>
                <Col xs="12" sm="4" className=" text-center mb-2 mb-md-3">
                  <div className="shadow-sm bg-white rounded-3 p-3">
                    <h5 className="text-dark fs-09">هیجان انگیزی </h5>
                    <Controller
                      name="isThriller"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <StarsComments
                          vlu={value}
                          indexChangeComment={2}
                          startsChange={(index, value) => {
                            setValue("isThriller", value);
                          }}
                          firstcount={11}
                        />
                      )}
                    />
                  </div>
                </Col>
              </Row>
              {errors.name && (
                <small className="text-danger fs-085">
                  لطفا نام و نام خانوادگی خود را وارد نمایید
                </small>
              )}
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <Form.Control
                    type="text"
                    name="name"
                    className="mb-3 fs-09"
                    placeholder="نام و نام خانوادگی"
                    value={value || ""}
                    onChange={onChange}
                  />
                )}
              />
              {errors.text && (
                <small className="text-danger  fs-085">
                  لطفا متن نظر را وارد نمایید
                </small>
              )}
              <Controller
                name="text"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <Form.Control
                    as="textarea"
                    rows={6}
                    name="text"
                    className="mb-3  fs-09"
                    placeholder="متن نظر"
                    value={value || ""}
                    onChange={onChange}
                  />
                )}
              />
              <Row className="gx-2">
                <Col xs="7">
                  <Button
                    variant="primary"
                    className="w-100 fs-09"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    ذخیره
                  </Button>
                </Col>
                <Col xs="5">
                  <Button
                    variant="outline-primary"
                    className="w-100 fs-09"
                    onClick={hideModal}
                  >
                    بازگشت
                  </Button>
                </Col>
              </Row>
            </form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default CommentSlider;
